import {
  PRICING_PLAN_QUANTITY,
  pricingPlanToRechargeSubscriptionProperty,
} from "@/constants/pricing";
import { PricingPlan } from "@/primary-models";
import {
  MEAL_PLAN_PRETTY_TITLES,
} from "libs/api/customer/src/lib/types/subscriptions";

export const MEAL_PLAN_STANDARD_CODE = pricingPlanToRechargeSubscriptionProperty[PricingPlan.STANDARD];
export const MEAL_PLAN_SAVER_CODE = pricingPlanToRechargeSubscriptionProperty[PricingPlan.SAVER];
export const MEAL_PLAN_HALF_CODE = pricingPlanToRechargeSubscriptionProperty[PricingPlan.HALF];
export const MEAL_PLAN_FREEZER_CODE = pricingPlanToRechargeSubscriptionProperty[PricingPlan.FREEZER];

export const MEAL_PLAN_STANDARD = {
  _uid: MEAL_PLAN_STANDARD_CODE,
  title: MEAL_PLAN_PRETTY_TITLES[MEAL_PLAN_STANDARD_CODE] as string,
  value: MEAL_PLAN_STANDARD_CODE,
  component: "select_option",
  advanced_options: {
    secondaryText: `${PRICING_PLAN_QUANTITY[PricingPlan.STANDARD]} days worth of food every 28 days`,
    tertiaryText: "£2.09/day",
  },
} as const;

export const MEAL_PLAN_SAVER = {
  _uid: MEAL_PLAN_SAVER_CODE,
  title: MEAL_PLAN_PRETTY_TITLES[MEAL_PLAN_SAVER_CODE] as string,
  value: MEAL_PLAN_SAVER_CODE,
  component: "select_option",
  advanced_options: {
    secondaryText: `${PRICING_PLAN_QUANTITY[PricingPlan.SAVER]} days worth of food every 42 days`,
    tertiaryText: "£1.99/day",
    tag: "Best value",
  },
} as const;

export const MEAL_PLAN_HALF = {
  _uid: MEAL_PLAN_HALF_CODE,
  title: MEAL_PLAN_PRETTY_TITLES[MEAL_PLAN_HALF_CODE] as string,
  value: MEAL_PLAN_HALF_CODE,
  component: "select_option",
  advanced_options: {
    secondaryText: `${PRICING_PLAN_QUANTITY[PricingPlan.HALF]} days worth of food every 56 days`,
    tertiaryText: "£1.05/day",
  },
} as const;

export const MEAL_PLAN_FREEZER = {
  _uid: MEAL_PLAN_FREEZER_CODE,
  title: MEAL_PLAN_PRETTY_TITLES[MEAL_PLAN_FREEZER_CODE] as string,
  value: MEAL_PLAN_FREEZER_CODE,
  component: "select_option",
  advanced_options: {
    secondaryText: `${PRICING_PLAN_QUANTITY[PricingPlan.FREEZER]} days worth of food every 14 days`,
    tertiaryText: "£2.30/day",
  },
} as const;

export const ALL_MEAL_PLANS = [
  MEAL_PLAN_STANDARD,
  MEAL_PLAN_SAVER,
  MEAL_PLAN_HALF,
  // FREEZER is not available for all customers, only for those who have limited freezer space
  // MEAL_PLAN_FREEZER,
];
